<div class="container">
  @if (isNativeIos) {
    <div class="no-role-card">
      <div class="icon-wrap">
        <qai-icon kind="info-circle" size="20px" />
      </div>
      <h2 class="title">{{ 'general.NO_ROLE_IOS_TITLE' | transloco }}</h2>
      <p class="body">
        {{ 'general.NO_ROLE_IOS_BODY_START' | transloco }}
        <a [href]="webAppUrl" target="_blank">{{ 'general.NO_ROLE_IOS_WEB_APP' | transloco }}</a>
        {{ 'general.NO_ROLE_IOS_BODY_END' | transloco }}
      </p>
    </div>
  } @else {
    <p>{{ 'general.NO_ROLE_WEB_MESSAGE' | transloco }}</p>
  }
</div>
